import { render, staticRenderFns } from "./bill-info.vue?vue&type=template&id=4415960e&scoped=true"
import script from "./bill-info.vue?vue&type=script&lang=js"
export * from "./bill-info.vue?vue&type=script&lang=js"
import style0 from "./bill-info.vue?vue&type=style&index=0&id=4415960e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4415960e",
  null
  
)

export default component.exports